<template>
  <div>
    <div class="z-[1] relative bg-purple-400 px-8 pb-24 pt-20 md:px-12 md:pb-32 md:pt-24">
      <div class="mx-auto max-w-5xl">
        <div class="flex flex-col items-start gap-7 text-left md:items-center md:text-center">
          <div class="text-lg font-medium lg:text-xl">{{ t('pages.features.customizable.hero.kicker') }}</div>
          <h2 class="text-5xl font-medium md:text-6xl lg:text-7xl xl:text-8xl">{{ t('pages.features.customizable.hero.title') }}</h2>
          <div class="max-w-3xl text-lg md:text-2xl lg:leading-10 xl:text-3xl">{{ t('pages.features.customizable.hero.body') }}</div>
        </div>
      </div>
    </div>

    <div class="z-[1] relative bg-[#e3cbff] flex flex-col overflow-hidden border-y border-black lg:flex-row">
      <div class="flex items-center justify-center border-b border-black bg-orange lg:order-2 lg:w-1/2 lg:border-b-0 lg:border-l md:p-6 p-2">
        <div class="relative">
          <SmartImage class="h-auto w-full" data-parallax="true" :alt="t('pages.features.customizable.hero.imageAlt')" src="/images/features/ext-links-w-editing.png" image-style="transform: translateY(0px);" />
          <SmartImage class="absolute -bottom-48 -left-4 w-48 transform-gpu -bottom-6 left-4 md:w-64 lg:-left-44 lg:w-96" data-parallax="true" :alt="t('pages.features.customizable.hero.overlayAlt')" src="/images/features/4x.png" image-style="transform: translateY(0px);" />
        </div>
      </div>
      <div class="flex items-center justify-center bg-black p-8 py-16 text-white sm:p-12 md:p-16 lg:w-1/2 xl:p-32">
        <div class="text-[#e3cbff] max-w-2xl space-y-12 md:space-y-16">
          <div class="space-y-4">
            <h3 class="text-3xl font-medium text-orange lg:text-4xl xl:text-5xl">
              {{ t('pages.features.customizable.blocks.mistakeChance.title') }}
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              <i18n-t keypath="pages.features.customizable.blocks.mistakeChance.body">
                <template #brand>
                  <span class="font-serif">ommi</span>
                </template>
              </i18n-t>
            </p>
          </div>
          <div class="space-y-4">
            <h3 class="text-3xl font-medium text-orange lg:text-4xl xl:text-5xl">
              {{ t('pages.features.customizable.blocks.misfitStories.title') }}
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              {{ t('pages.features.customizable.blocks.misfitStories.body') }}
            </p>
          </div>
          <!-- <div class="space-y-4">
            <h3 class="text-3xl font-medium text-orange lg:text-4xl xl:text-5xl">
              Links
            </h3>
            <p class="text-lg lg:text-xl xl:text-2xl">
              You can easily embed our payment platform and 'follow' button on your existing site.
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-col overflow-hidden border-t border-black lg:flex-row">
    <div class="z-[2] relative bg-[#e3cbff] flex items-center justify-center bg-yellow lg:w-1/2">
      <!-- <div class="absolute inset-0" role="presentation" aria-hidden="true" style="background: url(/images/features/shape.png) center no-repeat; background-size: cover zoom-in;"></div> -->
      <div class="relative p-0">
        <div class="relative">
          <SmartImage alt="Interactive graph showing sales analytics and growth metrics" class="h-auto w-full" data-parallax="true" src="/images/features/clicks.png" image-style="transform: translateY(0px);" />
          <SmartImage alt="new!" class="absolute -bottom-24 -right-8 w-32 transform-gpu sm:-bottom-20 sm:-right-20 sm:w-52 md:-bottom-24 md:-right-32 lg:-bottom-24 lg:-right-34 transform-gpu zoom-in rotate-180" data-parallax="true" src="/images/new.png" image-style="transform: translateY(0px);" />
        </div>
      </div>
    </div>

    <div class="z-[1] relative flex items-center justify-center bg-black p-8 py-16 text-white sm:p-12 md:p-16 lg:w-1/2 xl:p-32">
      <div class="max-w-2xl space-y-12 md:space-y-16">
        <div class="space-y-4">
          <h3 class="text-3xl font-medium text-orange lg:text-4xl xl:text-5xl">
            {{ t('pages.features.customizable.analytics.checkInterest.title') }}
          </h3>
          <p class="text-lg lg:text-xl xl:text-2xl">
            {{ t('pages.features.customizable.analytics.checkInterest.body') }}
          </p>
        </div>
        <div class="space-y-4">
          <h3 class="text-3xl font-medium text-orange lg:text-4xl xl:text-5xl">
            {{ t('pages.features.customizable.analytics.clickAnalytics.title') }}
          </h3>
          <p class="text-lg lg:text-xl xl:text-2xl">
            {{ t('pages.features.customizable.analytics.clickAnalytics.body') }}
          </p>
        </div>
        <div class="space-y-4">
          <h3 class="text-3xl font-medium text-orange lg:text-4xl xl:text-5xl">
            {{ t('pages.features.customizable.analytics.unusual.title') }}
          </h3>
          <p class="text-lg lg:text-xl xl:text-2xl">
            {{ t('pages.features.customizable.analytics.unusual.body') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '#imports'
import SmartImage from '~/components/SmartImage.vue'

const { t } = useI18n()
</script>
